import { IAppContext } from "./IAppContext";

import { createContext } from "react";

/**
 * This constant provides access to the context data of this app.
 */
export const AppContext = createContext<IAppContext>(null!);
